import { useEffect, useState } from 'react';
import { getSettings } from '@/services/apiService';

let cachedSettings = null;
const listeners = [];

async function loadSettings() {
  try {
    const s = await getSettings();
    cachedSettings = s;
    listeners.forEach((l) => l(s));
    return s;
  } catch { return cachedSettings; }
}

export function useSettings() {
  const [settings, setSettings] = useState(cachedSettings || { bs_rate: 40, pesos_rate: 4000, usd_discount_percent: 0 });
  useEffect(() => {
    let mounted = true;
    if (!cachedSettings) loadSettings().then((s) => { if (mounted && s) setSettings(s); });
    else setSettings(cachedSettings);
    const h = (s) => setSettings(s);
    listeners.push(h);
    return () => { mounted = false; const i = listeners.indexOf(h); if (i > -1) listeners.splice(i, 1); };
  }, []);
  return { settings, reload: loadSettings };
}
